export const UnicodeCharacterConstants = {
    Bullet: "\u2022",
    Copyright: "\u00A9",
    EmDash: "\u2014",
    EnDash: "\u2013",
    Registered: "\u00AE",
    TM: "\u2122",
};
